export const teamMembersList = [
    {
        id: 1,
        thumbnail: "/images/avatar/1.png",
        name: "Alexandra Della",
        position: "Frontend Developer",
        progress: 40,
        color:"#ea4d4d"
    },

    {
        id: 2,
        thumbnail: "",
        name: "Archie Cantones",
        position: "UI/UX Designer",
        progress: 65,
        color:"#3454d1"
    },
    {
        id: 3,
        thumbnail: "/images/avatar/3.png",
        name: "Malanie Hanvey",
        position: "Backend Developer",
        progress: 50,
        color:"#ffa21d"
    },
    {
        id: 4,
        thumbnail: "/images/avatar/7.png",
        name: "Kenneth Hune",
        position: "Digital Marketer",
        progress: 75,
        color:"#17c666"
    },
    {
        id: 5,
        thumbnail: "",
        name: "Timothy Boyd",
        position: "Fullstack Developer",
        progress: 75,
        color:"#17c666"
    },
    {
        id: 6,
        thumbnail: "/images/avatar/5.png",
        name: "Edward Andrade",
        position: "Fullstack Developer",
        progress: 75,
        color:"#17c666"
    },

]